import React from 'react';
import SyncStateComponent from './components/SyncStateComponent';

export default ({ element }: { element: React.ReactNode }) => {
  return <SyncStateComponent>{element}</SyncStateComponent>;
};
